import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { WpayTextTruncateComponent } from "./wpay-text-truncate.component";
import { MatLegacyTooltipModule as MatTooltipModule } from "@angular/material/legacy-tooltip";

@NgModule({
	declarations: [WpayTextTruncateComponent],
	imports: [CommonModule, MatTooltipModule],
	exports: [WpayTextTruncateComponent]
})
export class WpayTextTruncateModule {}
